export default __webpack_public_path__ + "static/media/sortSecond.1c756550.png";